var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgScroll7 = function SvgScroll7(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scroll_7_svg__scroll",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 167",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient",
    cx: -125.4724,
    cy: -23.0614,
    r: 229.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1848,
    stopColor: "#45a894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7386,
    stopColor: "#796792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e4e92"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient-2",
    cx: 28.3615,
    cy: 48.217,
    r: 41.8023,
    gradientTransform: "matrix(0.9999, 0.0133, -0.0133, 0.9999, 1.3366, -0.9026)",
    xlinkHref: "#scroll_7_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient-3",
    cx: -8.6042,
    cy: -54.7132,
    r: 192.7572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#329294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2637,
    stopColor: "#537993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5684,
    stopColor: "#736293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8247,
    stopColor: "#875392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e4e92"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient-4",
    cx: -56.2967,
    cy: -1.3444,
    r: 157.0071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0603,
    stopColor: "#3ab594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#5e8993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#786992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8476,
    stopColor: "#885592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e4e92"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient-5",
    cx: -67.9612,
    cy: 46.893,
    r: 107.3708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#35bc94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#608195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#7c5c96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864e96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient-6",
    cx: -25.2008,
    cy: 30.2548,
    r: 80.8996,
    xlinkHref: "#scroll_7_svg__radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient-7",
    cx: -68.5093,
    cy: 11.6716,
    r: 164.0392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#617eaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2609,
    stopColor: "#657dae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5254,
    stopColor: "#7078ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7905,
    stopColor: "#8271ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9669e4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient-8",
    cx: 104.7305,
    cy: 63.0601,
    r: 89.6682,
    gradientTransform: "translate(7.2742 0.9639) rotate(-1.9344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8756aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2565,
    stopColor: "#8658ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5165,
    stopColor: "#835cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7771,
    stopColor: "#7e65ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796ee6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient-9",
    cx: -17.4549,
    cy: 99.5515,
    r: 125.1712,
    gradientTransform: "translate(7.3128 0.9305) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b78d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2757,
    stopColor: "#6e74d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5552,
    stopColor: "#7668d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8354,
    stopColor: "#8354cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d44c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_7_svg__radial-gradient-10",
    cx: -124.7723,
    cy: 120.6841,
    r: 220.8207,
    gradientTransform: "translate(7.3128 0.9305) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#787dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3109,
    stopColor: "#7c7dd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6259,
    stopColor: "#887dd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#9c7eca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a17ec9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_7_svg__bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_7_svg__inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43,0,7,71,1,101q5.5,26.5,11,53l31,11,37-49L62,83Q52.5,41.5,43,0Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scroll_7_svg__shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,90l23,26L62,83Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,0q-.5,6-1,12L57,90l5-7Q52.5,41.5,43,0Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,71l9,16L42,12q.5-6,1-12Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,101l12,53q2-33.5,4-67Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,101,16,87,7,71Q3.5,86,0,101Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient-6)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_7_svg___Layer_",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,87q-2,33.5-4,67l3-3L46,95q-2-41.5-4-83Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,12q1,41,2,82l3,3,29,18,4,1L57,90Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,167l37-51L44,94q-.5,1.5-1,3-.5,34-1,68Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,94,12,154l31,13Q43.5,130.5,44,94Z",
    style: {
      fill: "url(#scroll_7_svg__radial-gradient-10)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "scroll_7_svg__highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,163l33-43L43,167,15,155l27,9q.5-12,1-24Q43.5,151.5,44,163Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,67V94L31,117,44,94Q43.5,80.5,43,67Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgScroll7);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scroll_7.1d5c6309e93b5770c189eec0326f7f04.svg";